<template>
    <v-content class="mb-7">
        <v-row>
          <OverallPerformance :external-user="false" :trades="this.$store.state.book.trades"/>
        </v-row>

        <v-divider class="my-3 mr-3"/>

        <v-row>
          <TradeList :shared="false"/>
        </v-row>

        <v-divider class="my-3 mr-3"/>

        <v-row>
          <v-card style="width: 100%" class="d-flex align-center justify-start pa-2" color="#E3E3E3" outlined>
            <v-icon class="mr-2" color="#6C7079" small>fa-cloud-upload-alt</v-icon>
            <h4 style="cursor: pointer" @click="importTradesOverlay">{{ $t('importTrades') }}</h4>
            <v-icon class="ml-7 mr-2" color="#6C7079" small>fa-plug</v-icon>
            <h4 style="cursor: pointer" @click="sendToAutomatedJournal">{{ $t('automatePlatform') }}</h4>
          </v-card>
        </v-row>

        <!-- Button for new trade !-->
        <v-btn @click="addTradeOverlay" bottom class="mr-7 mb-7" color="#00F784" dark fab fixed right>
            <v-icon>fa-plus</v-icon>
        </v-btn>

        <!-- Overlay for journal modes (No trades) !-->
        <v-overlay :value="overlayJournalModes">
            <JournalModes @importAdding="importAdding" @manuallyAdding="manuallyAdding" @closeWindow="overlayJournalModes = false"/>
        </v-overlay>

        <!-- Overlay for add trade !-->
        <v-overlay :value="overlay">
            <AddTrade @closeOverlay="overlay = false"  @tradesLimitReached="tradesLimitReached" @newTrade="newTrade"/>
        </v-overlay>

        <!-- Overlay for import trade !-->
        <v-overlay :value="overlayImportTrades">
            <ImportTrades @closeImport="overlayImportTrades = false"/>
        </v-overlay>

        <!-- Overlay for Upgrade to Pro!-->
        <v-overlay v-model="overlayUpgradeToPro">
            <UpgradeToPro :message="messageUpgradeToPro" @closeWindow="closeOverlayUpgradeToPro"/>
        </v-overlay>

        <!-- Overlay for Loading Trades!-->
        <v-overlay v-model="$store.state.book.loadingTrades">
            <lottie :options="lottieOptions" :height="250" :width="250"/>
        </v-overlay>
    </v-content>
</template>

<script>
    import * as animationData from '@/assets/animations/loading.json';
    import OverallPerformance from "../OverallPerformance";
    import TradeList from "../TradeList";
    import AddTrade from "../AddTrade";
    import UpgradeToPro from "../../../components/UpgradeToPro";
    import ImportTrades from "../components/ImportTrades";
    import JournalModes from "../components/JournalModes";

    export default {
        name: "BookHome",
        components: {JournalModes, ImportTrades, UpgradeToPro, AddTrade, TradeList, OverallPerformance},
        data() {
            return {
                lottieOptions: { animationData: animationData.default, },
                trades: this.$store.state.book.trades,
                filterTrades: [],
                overlay: false,

                overlayImportTrades: false,
                overlayJournalModes: false,
                swisetRatio: 0,
                winningRatio: 0,
                riskRewardRatio: 0,

                // Filters
                fromDateSelected: new Date().toISOString().substr(0, 10),
                toDateSelected: new Date().toISOString().substr(0, 10),
                sideSelected: 'All',
                brokerSelected: 'All',
                assetSelected: 'All',
                moodSelected: 'All',
                strategySelected: 'All',

                // Upgrade to pro
                overlayUpgradeToPro: false,
                messageUpgradeToPro: '',
            };
        },
        watch: {
          '$store.state.book.noTrades': function () {
            this.validateAddFirstTrade();
          },
        },
        mounted() {
          this.validateAddFirstTrade();
          this.$router.push("/journal/")
        },
        beforeMount() {
            //this.validateAuthenticated();
            //this.reset();
        },
        methods: {
            validateAddFirstTrade() {
              this.overlayJournalModes = this.$store.state.book.noTrades;
            },
            validateAuthenticated() {
                if(this.$store.state.token === '')
                    this.$router.push('/');
            },
            convertDuration(isoFormat){
                let iso8601DurationRegex = /(-)?P(?:([.,\d]+)Y)?(?:([.,\d]+)M)?(?:([.,\d]+)W)?(?:([.,\d]+)D)?T(?:([.,\d]+)H)?(?:([.,\d]+)M)?(?:([.,\d]+)S)?/;
                let matches = isoFormat.match(iso8601DurationRegex);

                return {
                    sign: matches[1] === undefined ? '+' : '-',
                    years: matches[2] === undefined ? 0 : matches[2],
                    months: matches[3] === undefined ? 0 : matches[3],
                    weeks: matches[4] === undefined ? 0 : matches[4],
                    days: matches[5] === undefined ? 0 : matches[5],
                    hours: matches[6] === undefined ? 0 : matches[6],
                    minutes: matches[7] === undefined ? 0 : matches[7],
                    seconds: matches[8] === undefined ? 0 : matches[8]
                };
            },
            reset() {
                this.filterTrades = this.trades;
                this.sideSelected = 'All';
                this.brokerSelected = 'All';
                this.assetSelected = 'All';
                this.moodSelected = 'All';
                this.strategySelected = 'All';
                this.getStats();
            },
            addTradeOverlay() {
                this.overlayJournalModes = true;
                //this.overlay = true;
            },
            importTradesOverlay() {
                if(!this.$store.state.user.isPro) {
                    this.messageUpgradeToPro = 'You cannot import trades. With Pro you can import historic trades from several platforms.';
                    this.overlayUpgradeToPro = true;
                }
                else
                    this.overlayImportTrades = true;
            },
            sendToAutomatedJournal() {
                window.open((this.$i18n.locale === "en")? 'https://swiset.com/automated-journal/' : 'https://swiset.com/es/journal-automatico/');
            },
            getStats(){
                let numberOfTrades = 0;
                let positiveTrades = 0;
                let positiveAvg = 0;
                let negativeAvg = 0;
                this.filterTrades.forEach((trade)=>{
                    if(trade.netProfit > 0) {
                        positiveTrades++;
                        positiveAvg += trade.netProfit;
                    }else
                        negativeAvg += trade.netProfit;

                    numberOfTrades++;
                });
                this.winningRatio = ((positiveTrades / numberOfTrades) * 100);
                this.riskRewardRatio = Math.abs((positiveAvg / positiveTrades) / (negativeAvg / (numberOfTrades - positiveTrades)) );
            },
            newTrade() {
                this.overlay = false;
            },
            tradesLimitReached() {
                this.messageUpgradeToPro = 'You reached the limit of trades for the month of this trade. With pro you can register unlimited trades.';
                this.overlayUpgradeToPro = true;
                this.overlay = false;
            },
            closeOverlayUpgradeToPro() {
                this.overlayUpgradeToPro = false;
            },
            manuallyAdding() {
                this.overlayJournalModes = false;
                this.overlay = true;
            },
            importAdding() {
                if(this.$store.state.user.isPro)
                    this.overlayJournalModes = false;
                this.importTradesOverlay();
            },
        }
    }
</script>

<i18n>
{
  "en": {
    "automatePlatform": "Automate your platform",
    "importTrades": "Import historic trades"
  },
  "es": {
    "automatePlatform": "Automatiza tu plataforma",
    "importTrades": "Importa trades históricos"
  }
}
</i18n>

<style scoped>

</style>
